module.exports = __webpack_public_path__ + "assets/img/00168.ee5baed4.png";